<div class="gc-chat-widget column-flex-container bc-work-item-theme {{ themeCssClassName$ | async }}">
  <app-genesys-chat-widget-header
    [contact]="contact$ | async"
    [isExpandedMode]="isExpandedMode()"
    [avatarThemeId]="avatarThemeId$ | async"
    [integrations]="integrations$ | async"
    [isCobrowseAllowed]="showCobrowseButton$ | async"
    [isCobrowseActive]="isCobrowseOpen$ | async"
    [openIntegrationPanels]="openIntegrationPanels$ | async"
    (minimize)="onMinimize()"
    (toggleExpanded)="onToggleExpanded()"
    (toggleIntegration)="onToggleIntegration($event)"
    (toggleCobrowse)="onToggleCobrowse($event)"
  >
  </app-genesys-chat-widget-header>

  <div
    class="gc-chat-widget-content column-flex-grow multilane-wrapper panel-shadow-wrapper"
    [class.collapsed]="!isExpandedMode()"
  >
    <ng-container *ngIf="(isCobrowseAllowed$ | async) && (isCobrowseOpen$ | async)">
      <div class="multilane-item multilane-item-2 cobrowse-box-container" [hidden]="!isExpandedMode()">
        <app-genesys-cobrowse-box
          [conversationId]="conversationId$ | async"
          [isExpandedMode]="isExpandedMode()"
          (toggleCobrowse)="onToggleCobrowse($event)"
        ></app-genesys-cobrowse-box>
      </div>
    </ng-container>
    <div class="multilane-item multilane-item-1 chat-box-container">
      <app-genesys-chat-box
        [contact]="contact$ | async"
        [conversationId]="conversationId$ | async"
        [conversationType]="conversationType$ | async"
        [agentParticipantId]="agentParticipantId$ | async"
        [isExpandedMode]="isExpandedMode()"
        [isConversationOpen]="isConversationOpen$ | async"
        [isMessagingPeriodEnded]="isMessagingPeriodEnded$ | async"
        [isConversationAcceptable]="isConversationAcceptable$ | async"
        [isWrapUpRequired]="isWrapUpRequired$ | async"
        [isCobrowseActive]="isCobrowseOpen$ | async"
      >
      </app-genesys-chat-box>
    </div>
    <ng-container *ngFor="let integration of openIntegrationPanels$ | async">
      <div [hidden]="!isExpandedMode()" class="multilane-item multilane-item-1 integration-panel bc-work-lane bc-panel">
        <app-genesys-integration-panel [integration]="integration" [conversation]="conversation$ | async">
        </app-genesys-integration-panel>
      </div>
    </ng-container>
  </div>
</div>
